module.exports = __webpack_public_path__ + "static/media/friedrice.abbb2ac8.jpg";